import { render, staticRenderFns } from "./WalletCard.vue?vue&type=template&id=3530cdc7"
import script from "./WalletCard.vue?vue&type=script&lang=js"
export * from "./WalletCard.vue?vue&type=script&lang=js"
import style0 from "./WalletCard.vue?vue&type=style&index=0&id=3530cdc7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports